import { type FC, type ReactNode, type MouseEventHandler, useCallback } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

import { useScrollCarousel } from 'dibs-scroll-carousel/exports/ScrollCarouselContext.ts';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { trackMainCarouselClick } from '../../respShared/PdpRespSharedHeroCarousel/tracking.ts';
import { type CarouselItem } from './types.ts';

const itemClassName = classnames(
    dibsCss.wFull,
    dibsCss.hFull,
    dibsCss.minH0,
    dibsCss.overflowHidden,
    dibsCss.flex,
    dibsCss.flexCol,
    dibsCss.itemsCenter,
    dibsCss.justifyCenter
);

export const CarouselItemWrapper: FC<{
    type: CarouselItem['__type'];
    openZoomModal: () => void;
    dataTn: string;
    children: ReactNode;
}> = ({ type, openZoomModal, dataTn, children }) => {
    const { activeSlide, totalSlides } = useScrollCarousel();
    const isZoomable = type === 'photo' || type === 'viewInRoom';

    const onClick: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement> = useCallback(
        event => {
            if (isZoomable) {
                trackMainCarouselClick({ activeSlide, totalSlides }, event);
            }
            openZoomModal();
        },
        [openZoomModal, activeSlide, totalSlides, isZoomable]
    );

    return isZoomable ? (
        <Link className={classnames(itemClassName, 'is-zoom')} onClick={onClick} dataTn={dataTn}>
            {children}
        </Link>
    ) : (
        <div className={itemClassName} data-tn={dataTn}>
            {children}
        </div>
    );
};
